/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BulkUpdateFacilityServiceAreasResponse } from './BulkUpdateFacilityServiceAreasResponse';
import {
    BulkUpdateFacilityServiceAreasResponseFromJSON,
    BulkUpdateFacilityServiceAreasResponseFromJSONTyped,
    BulkUpdateFacilityServiceAreasResponseToJSON,
} from './BulkUpdateFacilityServiceAreasResponse';

/**
 * 
 * @export
 * @interface BulkUpdateFacilityServiceAreas200Response
 */
export interface BulkUpdateFacilityServiceAreas200Response {
    /**
     * 
     * @type {BulkUpdateFacilityServiceAreasResponse}
     * @memberof BulkUpdateFacilityServiceAreas200Response
     */
    data?: BulkUpdateFacilityServiceAreasResponse;
}

/**
 * Check if a given object implements the BulkUpdateFacilityServiceAreas200Response interface.
 */
export function instanceOfBulkUpdateFacilityServiceAreas200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BulkUpdateFacilityServiceAreas200ResponseFromJSON(json: any): BulkUpdateFacilityServiceAreas200Response {
    return BulkUpdateFacilityServiceAreas200ResponseFromJSONTyped(json, false);
}

export function BulkUpdateFacilityServiceAreas200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUpdateFacilityServiceAreas200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : BulkUpdateFacilityServiceAreasResponseFromJSON(json['data']),
    };
}

export function BulkUpdateFacilityServiceAreas200ResponseToJSON(value?: BulkUpdateFacilityServiceAreas200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': BulkUpdateFacilityServiceAreasResponseToJSON(value.data),
    };
}

